import { Injectable } from '@angular/core';

// Interfaces
import { LocalStorageItem } from '../interfaces/local-storage-item.interface';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  getTipoUsuario(): string | null {
    return localStorage.getItem('pc_tipo_usuario');
  }

  clearLocalStorage(): void {
    localStorage.clear();
  }
  setItem(name: string, item: any): void {
    return localStorage.setItem(name, item);
  }

  setItems(items: LocalStorageItem[]): void {
    return items.forEach((item: LocalStorageItem) => {
      localStorage.setItem(item.name, item.item);
    });
  }
}
